export default __webpack_public_path__ + "7fabb18f25601d4e0581d3239a81a96f.gif";